import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faFacebook, faInstagram, faLinkedin, } from '@fortawesome/free-brands-svg-icons';
import * as typeformEmbed from "@typeform/embed";
import logoWhite from "../../static/images/evitat-logo-white.png"
import CookieConsent, { Cookies } from "react-cookie-consent";
import { graphql, Link } from 'gatsby'
export class Footer extends React.Component {
  // openForm = () => {
  //     this.typeformEmbed.typeform.open();
  // }
  componentDidMount() {
    
    const subscriptionForm = typeformEmbed.makePopup(
      "https://form.typeform.com/to/kCgxiYPm",
      {
        mode: "popup",
        autoClose: 3000,
        hideHeader: true,
        hideFooters: true,
        onSubmit: function () {
          console.log("Subscription successful")
        },
      }
    )
    const contactForm = typeformEmbed.makePopup(
      "https://form.typeform.com/to/cjN3ZPe8",
      {
        mode: "drawer_right",
        autoClose: 3000,
        hideHeader: true,
        hideFooters: true,
        onSubmit: function () {
          console.log("Contact successful")
        },
      }
    )
    document.getElementById("bt-subs")?.addEventListener("click", e => {
      e.preventDefault()
      subscriptionForm.open()
    })
    document.getElementById("bt-contact")?.addEventListener("click", e => {
      e.preventDefault()
      contactForm.open()
    })
  }
  cookieAccept() {
   Cookies.set('gatsby-gdpr-facebook-pixel', true, {expires: 365});
   Cookies.set('gatsby-gdpr-google-tagmanager', true, {expires: 365});
  }
  cookieDecline() {
    Cookies.remove('gatsby-gdpr-facebook-pixel');
    Cookies.remove('gatsby-gdpr-google-tagmanager');
  }
  render () {

      return <footer className="footer">
      <div className="footer__container">
      <div className="footer__logo">
          <img src={logoWhite} alt="Logo" className="footer__logo" width="100" />
      </div>
      <div className="footer__column">
          <dl>
              <dt>Legal</dt>
              <dd><a href="https://www.evitat.com.au/privacy" >Privacy policy</a></dd>
          </dl>
      </div>
      <div className="footer__column">
          <dl>
              <dt> Hello Evitat</dt>
              <dd><a id="bt-contact">Contact Us</a></dd>
          </dl>
  
          <div className="footer__socialMedia">
          
              <ul>
              <li>    <a className="fa" href="https://www.facebook.com/be.evitat/?view_public_for=105639277979395"><FontAwesomeIcon icon={faFacebook} /></a></li>
                      <li><a href="https://www.instagram.com/be.evitat/" className="fa"><FontAwesomeIcon icon={faInstagram} /></a></li>
                      <li><a href="https://www.linkedin.com/company/evitat" className="fa"><FontAwesomeIcon icon={faLinkedin} /></a></li>
              </ul>
          </div>
          
      </div>
      </div>
      <CookieConsent
        location="bottom"
        buttonText="Accept"
        disableStyles={true}
        declineButtonText="Decline"
        enableDeclineButton
        onAccept={this.cookieAccept}
        onDecline={this.cookieDecline}
        buttonClasses="cookie-pop__btn accept"
        declineButtonClasses="cookie-pop__btn decline"
        containerClasses="cookie-pop__container"
        contentClasses="cookie-pop__content"
      >
        <p>This website stores cookies on your computer. These cookies are used to collect information about how you interact with this website and allow us to remember you.
We use this information in order to improve and customize your browsing experience and for analytics and metrics about our visitors on this website.
<br/><br/>
If you decline, your information won’t be tracked when you visit this website. A single cookie will be used in your browser to remember your preference not to be tracked.
        <Link to="/cookie-policy"> See Details</Link>
        </p>
      </CookieConsent>
      </footer>;
  }
}












